import "./App.css";
import React, { Component } from "react";
import axios from "axios";

class App extends Component {
  state = {
    selectedFile: null,
    fileUploadedSuccesfully: false,
    isUploading: false,
    fileType: null, // 'csv' o 'excel'
  };

  // Función unificada para detectar y manejar archivos
  onFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Detectar tipo de archivo
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.split('.').pop();
    
    let fileType = null;
    if (fileExtension === 'csv') {
      fileType = 'csv';
    } else if (['xlsx', 'xls'].includes(fileExtension)) {
      fileType = 'excel';
    } else {
      alert("Tipo de archivo no soportado. Por favor selecciona un archivo CSV o Excel.");
      return;
    }

    this.setState({ 
      selectedFile: file, 
      fileType: fileType,
      fileUploadedSuccesfully: false 
    });
  };

  // Función unificada para cargar archivos
  onFileUpload = async () => {
    if (!this.state.selectedFile) {
      alert("Por favor selecciona un archivo primero.");
      return;
    }

    // Iniciar estado de carga
    this.setState({ isUploading: true });

    try {
      if (this.state.fileType === 'csv') {
        await this.uploadCSV();
      } else if (this.state.fileType === 'excel') {
        await this.uploadExcel();
      }
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      alert("Hubo un error al subir el archivo. Inténtalo de nuevo.");
      this.setState({ isUploading: false });
    }
  };

  // Función para cargar CSV
  uploadCSV = async () => {
    const formData = new FormData();
    formData.append("demo file", this.state.selectedFile, this.state.selectedFile.name);

    await axios.post(
      "https://p9blp1rmy8.execute-api.us-east-1.amazonaws.com/prod/file-upload/",
      formData
    );

    this.setState({
      selectedFile: null,
      fileUploadedSuccesfully: true,
      isUploading: false,
      fileType: null,
    });
    alert("Archivo CSV subido con éxito.");
  };

  // Nueva función para obtener URL pre-firmada
  getPresignedUrl = async (fileName, contentType) => {
    try {
      const response = await axios.get(
        `https://94cgu3pzsf.execute-api.us-east-1.amazonaws.com/PRO/presigned-url?fileName=${encodeURIComponent(fileName)}&contentType=${encodeURIComponent(contentType)}`,
        {
          headers: {
            "x-api-key": "ro9TNKarWh4OOOitpaEmk94FsTt7vl6X7dAe4g4D"
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo URL pre-firmada:", error);
      throw error;
    }
  };

  // Nueva función para subir directamente a S3
  uploadToS3 = async (file, presignedUrl) => {
    try {
      const response = await fetch(presignedUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return response;
    } catch (error) {
      console.error("Error subiendo a S3:", error);
      throw error;
    }
  };

  // Nueva función para notificar procesamiento
  notifyProcessing = async (s3Key, fileName, bucket) => {
    try {
      const response = await axios.post(
        "https://94cgu3pzsf.execute-api.us-east-1.amazonaws.com/PRO/files",
        {
          s3Key: s3Key,
          fileName: fileName,
          bucket: bucket,
          action: "process"
        },
        {
          headers: {
            "x-api-key": "ro9TNKarWh4OOOitpaEmk94FsTt7vl6X7dAe4g4D",
            "Content-Type": "application/json"
          }
        }
      );
      return response;
    } catch (error) {
      console.error("Error notificando procesamiento:", error);
      throw error;
    }
  };

  // Función para cargar Excel
  uploadExcel = async () => {
    const fileName = this.state.selectedFile.name;
    const contentType = this.state.selectedFile.type;

    // 1. Obtener URL pre-firmada
    console.log("Obteniendo URL pre-firmada...");
    const { uploadUrl, key, bucket } = await this.getPresignedUrl(fileName, contentType);

    // 2. Subir archivo directamente a S3
    console.log("Subiendo archivo a S3...");
    await this.uploadToS3(this.state.selectedFile, uploadUrl);

    // 3. Notificar procesamiento
    console.log("Notificando procesamiento...");
    await this.notifyProcessing(key, fileName, bucket);

    this.setState({
      selectedFile: null,
      fileUploadedSuccesfully: true,
      isUploading: false,
      fileType: null,
    });
    alert("Archivo Excel subido con éxito.");
  };

  // Función unificada para mostrar detalles del archivo
  fileData = () => {
    if (this.state.isUploading) {
      return (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <div className="loading-spinner"></div>
          <h4 style={{ color: '#FF7E31', marginTop: '10px' }}>
            Por favor espere, se está cargando su archivo...
          </h4>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Esto puede tomar unos momentos dependiendo del tamaño del archivo
          </p>
        </div>
      );
    } else if (this.state.selectedFile) {
      const fileTypeText = this.state.fileType === 'csv' ? 'CSV' : 'Excel';
      return (
        <div>
          <h2>Detalles del archivo {fileTypeText}:</h2>
          <p>Nombre: {this.state.selectedFile.name}</p>
          <p>Tipo: {this.state.selectedFile.type}</p>
          <p>Tamaño: {(this.state.selectedFile.size / 1024 / 1024).toFixed(2)} MB</p>
        </div>
      );
    } else if (this.state.fileUploadedSuccesfully) {
      return (
        <div>
          <br />
          <h4 style={{ color: '#28a745' }}>✓ El archivo ha sido cargado exitosamente</h4>
        </div>
      );
    } else {
      return (
        <div>
          <br />
          <h4>Selecciona un archivo CSV o Excel y haz click en cargar</h4>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Formatos soportados: .csv, .xlsx, .xls
          </p>
        </div>
      );
    }
  };

  render() {
    return (
      <div className="container">
        <h1>Cargar archivos CSV y Excel</h1>
        <div className="buttons">
          <input
            className="inputFile"
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={this.onFileChange}
            disabled={this.state.isUploading}
          />
          <button 
            onClick={this.onFileUpload}
            disabled={this.state.isUploading || !this.state.selectedFile}
            style={{
              opacity: (this.state.isUploading || !this.state.selectedFile) ? 0.6 : 1,
              cursor: (this.state.isUploading || !this.state.selectedFile) ? 'not-allowed' : 'pointer'
            }}
          >
            {this.state.isUploading ? 'Cargando...' : 'Cargar archivo'}
          </button>
        </div>
        {this.fileData()}
      </div>
    );
  }
}

export default App;